export enum EnumRegisterName {
  HAE = "HAE",
  SERBVASC = "SERBVASC",
  CHARGER = "CHARGER",
  PHREGISTAR = "PHREGISTAR",
}
